import EverCookie from 'EverCookie';
import { type ConfirmOTPResponse } from 'interfaces/connectionType';
import {
  persistTokenExpiration,
  setSessionUUIDToken,
  setStorageToken,
  setUserUUIDToken,
  syncSentryContext,
} from 'utils';

export const storageAuthTokens = (response: ConfirmOTPResponse, userUUID: string | null) => {
  setStorageToken(response?.jwt_token);
  persistTokenExpiration(response?.jwt_token, response?.jwt_token_expired_at);
  setUserUUIDToken(response?.user_uuid);
  setSessionUUIDToken(response?.session_uuid);

  if (userUUID) {
    const EC = new EverCookie('EverCookie');
    EC.setItem(false, 'userID', userUUID.toString());
  }

  syncSentryContext();
};
